import { gql } from '@apollo/client';

export const DELETE_SELECTED_CAMPAIGN_MESSAGES = gql`
  mutation DeleteSelectedCampaignMessages($ids: [ID!]!) {
    deleteSelectedCampaignMessages(input: { ids: $ids }) {
      success
      deletedCount
      errors
    }
  }
`;